module.exports = __webpack_public_path__ + "static/media/patente-shield.f3b13740.svg";